import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { FormGroup } from '@/components/element/Form/FormGroup';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useNavState } from '@/providers/NavStateProvider';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { toastApiError, toastSuccess } from '@/lib/toast';
import { useCreateMoneyForwardSetting } from '@/hooks/api/2220_create_money_forward_setting';
import Cookies from 'js-cookie';
import { useWorkspaceInvalidate } from '@/hooks/api/0101_workspace';

export const MoneyForwardConnectCallback = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('新規Money Forward接続'), []);
  useEffect(() => setBreadcrumbs([{ label: `外部サービス連携`, path: `/w/${_w_!.identifier}/setting/connect` }]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [clientId, setClientId] = useState<string>();
  const [clientSecret, setClientSecret] = useState<string>();
  const [code, setCode] = useState<string>();
  const [redirectUri, setRedirectUri] = useState(
    `${process.env.REACT_APP_SITE_URL}/w/${_w_!.identifier}/setting/connect/mf/callback`
  );
  const { mutate, data, isPending, error } = useCreateMoneyForwardSetting();
  const { invalidate: invalidateWorkspace } = useWorkspaceInvalidate(_w_!.identifier);

  useEffect(() => {
    const _clientId = Cookies.get('mf_client_id');
    const _clientSecret = Cookies.get('mf_client_secret');
    const _code = params.get('code');
    if (_clientId && _clientSecret && _code) {
      setClientId(_clientId);
      setClientSecret(_clientSecret);
      setCode(_code);

      mutate({ identifier: _w_!.identifier, client_id: _clientId, client_secret: _clientSecret, code: _code });
    } else {
      navigate(`/w/${_w_!.identifier}/setting/connect`);
    }
  }, []);

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (error) {
      toastApiError(error);
      navigate(`/w/${_w_!.identifier}/setting/connect`);
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      invalidateWorkspace();
      toastSuccess('Money Forward連携が完了しました');
      navigate(`/w/${_w_!.identifier}/setting/connect`);
    }
  }, [data]);

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'connect'} />
      </div>

      <div className="row">
        <div className="col-12 col-lg-9 mx-auto">
          <div className="card mb-4" id="basic-info">
            <div className="card-header d-flex align-items-center">
              <div className="col-md-8">
                <h5 className="mb-1">新規Money Forward接続</h5>
              </div>
            </div>

            <div className="card-body pt-0">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Client ID</label>
                  <div className="d-flex align-items-center">
                    <input type="text" className={'form-control'} disabled={true} value={clientId} />
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label>Client Secret</label>
                  <div className="d-flex align-items-center">
                    <input type="text" className="form-control" disabled={true} value={clientSecret} />
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label>リダイレクトURI</label>
                  <div className="d-flex align-items-center">
                    <input type="text" className="form-control" disabled={true} value={redirectUri} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
